export const UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE'



// WEBPACK FOOTER //
// ./src/types/currentPage.js